import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import {
    Card,
    CardMedia,
    CardActions,
    IconButton,
    Box,
    useMediaQuery,
} from "@mui/material";
import { Favorite, FavoriteBorder, UploadFile } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const Banner = ({ images }) => {
    const [liked, setLiked] = useState({});
    const fileInputRefs = useRef([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const toggleLike = (index) => {
        setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const handleUploadClick = (index) => {
        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].click();
        }
    };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            console.log(`Uploaded file for image ${index}:`, file);
            // Handle upload logic here
        }
    };

    console.log("images", images);
    console.log(process.env.REACT_APP_DOC_URL + '/' + images[0]?.imageUrl);

    return (
        <Swiper slidesPerView={1} className="mySwiper">
            {images.map((img, index) => (
                <SwiperSlide key={index}>
                    <Card
                        sx={{
                            width: { xs: '100%', sm: "100%" },
                            height: { xs: 'auto', sm: 450 },
                            aspectRatio: { xs: '4 / 3', sm: 'auto' }, // maintains 4:3 on mobile
                            mx: "auto",
                            boxShadow: 3,
                            borderRadius: 2,
                            overflow: "hidden",
                            my: 2,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={`${process.env.REACT_APP_DOC_URL}/${img?.imageUrl}`}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://fakeimg.pl/400x300/e60c0c/141313?font=bebas";
                            }}
                            alt={`${img?.name} image`}
                            sx={{
                                width: "100%",
                                height: { xs: "auto", sm: "calc(100% - 48px)" },
                                objectFit: "cover",
                                flexGrow: 1,
                            }}
                        />
                        <CardActions
                            sx={{
                                justifyContent: "space-between",
                                height: 48,
                                px: 1,
                            }}
                        >
                            <IconButton onClick={() => toggleLike(index)} color="error">
                                {liked[index] ? <Favorite /> : <FavoriteBorder />}
                            </IconButton>
                            <Box>
                                <input
                                    type="file"
                                    hidden
                                    ref={(el) => (fileInputRefs.current[index] = el)}
                                    onChange={(e) => handleFileChange(e, index)}
                                />
                                <IconButton color="primary" onClick={() => handleUploadClick(index)}>
                                    <UploadFile />
                                </IconButton>
                            </Box>
                        </CardActions>
                    </Card>

                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default Banner;
